export default {
    errorMsg: "登入信息有誤，請重新登入"
}